export default __webpack_public_path__ + "images/logoKellyRyan.79252bb13377e57adca04db37a9b122c.svg"